export default __webpack_public_path__ + "static/avatar-f89d3b18f0517826d275218674ccb8ea.jpg";